var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessBlackB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 625 864",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-191,-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_blackB",
    d: "M500,65C450.816,64.937 412.454,110.1 415,163C417.498,214.903 435.334,239.529 455,260C418.661,292.032 263.823,487.872 263,575C262.177,662.128 309.145,740.058 352,764C303.424,763.425 307.657,764.721 263,766C199.355,767.823 197.502,884.234 262,883C316.253,881.962 695.472,883.093 748,882C806.539,880.781 808.489,771.338 744,771C671.511,770.62 655,768 655,768C730.365,680.756 752.319,615.752 752,580C751.681,544.248 733.403,458.093 699,420C661.703,459.875 575.367,549.994 545,580C497.037,627.393 438.166,567.088 482,519C510.683,487.533 634,354 634,354L540,258C588.436,228.626 597.298,184.262 597,164C596.437,125.741 568.784,65.089 500,65Z",
    style: {
      stroke: "black",
      strokeWidth: "45.83px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessBlackB);
export default __webpack_public_path__ + "static/media/chess_blackB.314229f254f0e87a32fed4e755384a2f.svg";
export { ForwardRef as ReactComponent };